import { LeftSidebarListItem } from '../../../Common/Layout/models/left-sidebar-list-item.model';
import { LeftSidebarListItemButton } from '../../../Common/Layout/models/left-sidebar-list-item-button.model';
import { LeftSidebarListItemConvertableModel } from '../../../Common/Layout/models/left-sidebar-list-item-convertable.model';
import { NewswireReleaseSummaryModel } from '../../../api/wire/models/newswire-release-summary.model';
import { ReleaseStatus } from '../../../api/wire/enums/release-status.enum';
import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
import { ActionsEnum } from '../../../Common/Basic/enums/actions.enum';
export class WireListItemModel implements AuditableModel, LeftSidebarListItemConvertableModel {
    public id: number;
    public name: string;
    public status: ReleaseStatus;
    public createdDate: Date;
    public createdByUserId: number;
    public modifiedDate: Date;
    public modifiedByUserId: number;
    public hidden?: boolean;
    public groupId: number;
    public isFavorite: boolean = false;

    constructor(apiModel?: NewswireReleaseSummaryModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.status = apiModel.status;
            this.createdDate = apiModel.createdDate;
            this.createdByUserId = apiModel.createdUserId;
            this.modifiedDate = apiModel.modifiedDate;
            this.modifiedByUserId = apiModel.modifiedUserId;
            this.hidden = apiModel.hidden;
            this.groupId = apiModel.displayGroupId;
            this.isFavorite = apiModel.isFavorited;
        } else {
            this.id = null;
            this.name = null;
            this.status = ReleaseStatus.draft;
            this.createdDate = null;
            this.createdByUserId = null;
            this.modifiedDate = null;
            this.modifiedByUserId = null;
            this.hidden = false;
        }
    }

    public toLeftSidebarListItem(buttons: LeftSidebarListItemButton[] = []): LeftSidebarListItem {
        if (buttons){
            if (this.hidden){
                buttons = buttons.filter(button => button.key !== ActionsEnum.hide);
            } else {
                buttons = buttons.filter(button => button.key !== ActionsEnum.show);
            }
            if (this.isFavorite) {
                buttons = buttons.filter(button => button.key !== ActionsEnum.favorite);
            } else {
                buttons = buttons.filter(button => button.key !== ActionsEnum.unfavorite);
            }
        }
        return {
            value: this.id,
            label: this.name,
            status: this.status,
            buttons: buttons,
            groupId: this.groupId,
            isFavorite: this.isFavorite
            // lastModifiedDate: this.modifiedDate || this.createdDate
        };
    }
}
